"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSubredditPosts = fetchSubredditPosts;
exports.normalizeRedditListing = normalizeRedditListing;
/**
 * Normaliza la respuesta JSON de Reddit para listar publicaciones de un sub.
 *
 * En Electron se usa `electronAPI.redditGetPosts` (main process + User-Agent válido).
 * En navegador puede fallar por CORS; el panel mostrará el enlace al sub.
 */

/**
 * @param {object} raw - JSON de /r/{sub}/{sort}.json
 * @returns {Array<{ title: string, url: string, permalink: string,
 *                  score: number, numComments: number }>}
 */
function normalizeRedditListing(raw) {
  const children = raw?.data?.children;
  if (!Array.isArray(children)) {
    return [];
  }
  return children.map(c => c && c.data).filter(Boolean).map(d => {
    let url = d.url || '';
    if (url && !url.startsWith('http')) {
      url = `https://www.reddit.com${url}`;
    }
    const permalink = d.permalink ? `https://www.reddit.com${d.permalink}` : '';
    return {
      title: d.title || '(sin título)',
      url: url || permalink,
      permalink,
      score: typeof d.score === 'number' ? d.score : 0,
      numComments: typeof d.num_comments === 'number' ? d.num_comments : 0
    };
  });
}

/**
 * @param {{
 *   subreddit: string,
 *   sort?: string,
 *   limit?: number,
 *   oauthClientId?: string,
 *   oauthClientSecret?: string,
 * }} opts
 * @returns {Promise<Array>}
 */
async function fetchSubredditPosts(opts) {
  const subreddit = String(opts.subreddit || '').trim();
  const sort = opts.sort || 'hot';
  const limit = opts.limit || 15;
  if (!subreddit) {
    return [];
  }
  if (typeof window !== 'undefined' && window.electronAPI && typeof window.electronAPI.redditGetPosts === 'function') {
    const raw = await window.electronAPI.redditGetPosts({
      subreddit,
      sort,
      limit,
      oauthClientId: opts.oauthClientId || '',
      oauthClientSecret: opts.oauthClientSecret || ''
    });
    return normalizeRedditListing(raw);
  }
  return [];
}